import DOMPurify from "dompurify";

interface NotificationBodyProps {
    body: string;
}

export default function NotificationBody({body}: NotificationBodyProps) {
    return <div className="notification-body" dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize(body)
    }}></div>
}
